/**
 * CDN placeholders for cards without a ЖК photo.
 * Replace these URLs after the three final images are uploaded.
 */
export const POPULAR_NEWBUILDING_PLACEHOLDER_IMAGE_URLS = [
  'https://cdn.cian.site/frontend/recommendations-micro-frontend/popular-newbuilding-placeholder-1.png',
  'https://cdn.cian.site/frontend/recommendations-micro-frontend/popular-newbuilding-placeholder-2.png',
  'https://cdn.cian.site/frontend/recommendations-micro-frontend/popular-newbuilding-placeholder-3.png',
];

export const POPULAR_NEWBUILDING_CARDS_BEFORE_TABLET_BREAKPOINT = 5;
export const POPULAR_NEWBUILDING_CARDS_AFTER_TABLET_BREAKPOINT = 4;
